import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import MainTable from "../../../components/tables/MainTable";
import endpoints from "../../../services/endpoints";
import { TableDetailsItem } from "../../../components/tables/tableFunctions";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";

export default function RegionalOffice() {
  const navigation = useNavigate();
  const { regionalOfficeList } = endpoints;
  const pathname = useSelector((state: RootState) => state.geolocation.previousUrl);
  const TableDetails: { [key: string]: TableDetailsItem } = {
    "Regional Office Name": {
      id: "name",
      className: "min-w-[230px]",
    },
    "Admin Cashier Name": {
      id: "admin_cashier_name",
      className: "min-w-[230px]"
    },
    "Contact Details of Cashier": {
      id: "cashier_phone_number",
      custom:['country_code','cashier_phone_number']
    },
    "Address": {
      id: "charge_value_with_mode",
      custom:['country', 'province', 'region'],
      className: "min-w-[250px]",
    },
    'Actions': {
      sort: false,
      id: "actions",
      className: "min-w-[200px]", // Adding className here
      actionTypes: ["edit"],
    },
  };
  const handleActions = (id: string, key: string) => {
    if (key === 'edit') {
      navigation(`/other-resources/regional-offices/edit-regional-office/${id}`)
    }
  };
  const addButtonClick = () => {
    navigation("/other-resources/regional-offices/add-regional-office");
  };
  const staticText = {
    emptyScreenText: {
      heading1: "There are no regional offices added yet",
      heading2: "Click “Add Regional Office to create one",
    },
  };
  return (
    <div>
      <Breadcrumbs
        navPath={["Other Resources","Regional Office", "List of Regional Office"]}
        heading="List of Regional Offices"
        noNavigation
        links={pathname ? [pathname, pathname] : ['/other-resources/regional-offices','/other-resources/regional-offices']}
        button={{
          buttonName: "Add Regional Office",
          className: "px-4 whitespace-nowrap",
          buttonOnclick: addButtonClick, // Corrected function type
        }}
        list={true}
      />
       <MainTable
        staticText={staticText}
        mainEndPoint={regionalOfficeList}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{'page_number' : '1'}}
        searchPlaceholder={'Search by regional office name'}
        filters={false}
        exporting={false}
        displayTotalRecords
        notfoundRoute={{ state: { route: '/other-resources/regional-offices' } }}
        title="Regional Offices"
      />
    </div>
  );
}
